import { useState } from 'react';

type SetValue<T> = T | ((val: T) => T) | undefined;

export function useLocalStorage<T>(
  key: string,
  initialValue?: T
): [T, (value: SetValue<T>) => void] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: SetValue<T>): void => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      if (valueToStore === undefined) {
        window.localStorage.removeItem(key);
        setStoredValue(undefined as unknown as T);
        return;
      }
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.log(error);
    }
  };

  return [storedValue, setValue];
}
